import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';

export function useCreateAccountMutation({
	onError,
	onSuccess,
}: {
	onError?: (err: Api.IOperationResultNoValue) => void;
	onSuccess?: (value: Api.IAccount) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ account }: { account: Api.IAccount }) => {
			return userSession.webServiceHelper.callAsync<Api.IAccount>('account', 'POST', account);
		},
		onError,
		onSuccess,
	});
}
